<!-- FIREBASE V9 -->
<template>
    <v-container fluid>
        <v-card class="ma-2" outlined>
            <v-card-title>
                <v-btn icon @click="$router.go(-1)">
                    <v-icon>mdi-chevron-left</v-icon>
                </v-btn>
                {{ title }}
                <v-spacer></v-spacer>
                <v-btn color="primary" dark class="ml-5 mt-3" @click="goToCoachList"> Coach ({{ coachNumber }})</v-btn>
            </v-card-title>
            <v-progress-linear indeterminate color="yellow darken-2" v-if="loading"></v-progress-linear>
    
            <!-- Dialog for confirm update user -->
            <v-dialog v-model="dialog" max-width="400px">
                <v-card>
                    <v-card-title class="text">Done!</v-card-title>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" text @click="goToItemList">OK</v-btn>
                        <v-spacer></v-spacer>
                    </v-card-actions>
                </v-card>
            </v-dialog>
    
            <v-form ref="form" lazy-validation v-model="valid" class="ma-5 pa-5">
                <v-layout wrap="true">
                    <v-flex xs12 md1 class="d-none d-md-inline">
                        <p class="text-subtitle-1 bg2-text text-md-right mr-md-3">ชื่อ</p>
                    </v-flex>
                    <v-flex xs12 md1 class="d-md-none">
                        <p class="text-subtitle-1 text-md-right mr-md-3">ชื่อ</p>
                    </v-flex>
                    <v-flex xs12 md7>
                        <v-textarea outlined :rules="requiredRule" v-model="editedItem.name" class="d-flex xs12 md7">
                        </v-textarea>
                    </v-flex>
                </v-layout>

                <br />
                <v-layout wrap="true">
                    <v-flex xs12 md8 text-right>
                        <v-btn d-flex color="blue darken-1" text @click="goToItemList"> Cancel </v-btn>
                        <v-btn v-if="this.id" color="blue darken-1" text @click="submit">
                            Update
                        </v-btn>
                        <v-btn v-else color="blue darken-1" text @click="submit">
                            Add
                        </v-btn>
                    </v-flex>
                </v-layout>
            </v-form>
        </v-card>
    </v-container>
    </template>
    
    <script>
    import firebase from "firebase/compat/app";
    import "firebase/compat/auth";
    import {
        mapGetters
    } from "vuex";
    import getOrgList from '../data/getOrgList';
    import setOrgInfo from '../data/setOrgInfo';
    import getUserCoachList from "../data/getUserCoachList";
    export default {
        name: 'OrganizationForm',
        metaInfo: {
            title: 'Organization Form'
        },
        data() {
            return {
                editedItem: {
                    name: ""
                },
                defaultItem: {
                    name: ""
                },
                //to validate from
                valid: false,
                requiredRule: [
                    (value) => !!value || "Required."
                ],
                refRule: [
                    (value) => !!value || "Required.",
                ],
                dialog: false,
                title: "Add new Org",
                coachNumber: 0,
                loading: false
            };
        },
    
        created() {
            var vm = this;
            vm.$store.state.appTitle = "Thaisook Web Admin | Organization";
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    vm.$store.dispatch("autoSignIn", user);
                    this.loading = true;
                    setTimeout(() => {
                        vm.initialize();
                    }, "1000");
                } else {
                    console.log("no user");
                }
            });
            this.id = this.$route.params.id;
        },
        computed: {
            ...mapGetters([
                "loggedInUserId",
                "isAuthenticated",
                "isSuperAdmin",
                "isChallengeAdmin",
                "isAccessOrgAdmin"
            ])
        },
        methods: {
            initialize() {
                if (this.isSuperAdmin || this.isAccessOrgAdmin) {
                    (async () => {
                        if (this.id) {
                            this.title = 'Edit Org';
                            this.editedItem = await getOrgList(this.id);

                            //to show coach number next to button coach list
                            const coachInfo = await getUserCoachList(this.editedItem.name);
                            this.coachNumber = coachInfo.length;
                        }
                        this.loading = false;
                    })();
                } else {
                    this.$router.push(`/dashboard`);
                }
            },
            submit() {
                (async () => {
                    //to validate from before submit
                    await this.$refs.form.validate();
    
                    if (this.valid) {
                        (async () => {
                            if (this.id) {
                                this.editedItem.updatedDate = new Date();
                                this.editedItem.updatedBy = this.loggedInUserId;
                                await setOrgInfo(this.editedItem, this.id);
                            } else {
                                this.editedItem.createdDate = new Date();
                                this.editedItem.createdBy = this.loggedInUserId;
                                this.editedItem.updatedDate = new Date();
                                this.editedItem.updatedBy = this.loggedInUserId;
                                await setOrgInfo(this.editedItem);
                            }

                            setTimeout(() => {
                                this.dialog = true;
                            }, "3000");
                        })();
                    }
                })();
            },
            close() {
                this.dialog = false;
            },
            goToItemList() {
                this.$router.push(`/org`);
            },
            goToCoachList(){
                this.$router.push(`/org-coach/${this.id}`);
            }
        },
    };
    </script>
    
    <style>
    .v-textarea textarea {
        height: 70px;
    }
    p{
        margin-bottom: 0!important;
    }
    p.bg2-text{
        line-height: 47px!important;
        text-align: right;
    }
    p.bg-text{
        line-height: 55px!important;
        text-align: right;
    }
    </style>
    